import { useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { api } from "@/lib/apiClient";
import { MILESTONES } from "@/components/LevelBadge";
import { X } from "lucide-react";

const NOTE = {
  gift_250: "You've given $250 or more. Thank you for being a Faithful Giver.",
  gift_1000: "You've crossed $1,000 in lifetime giving. You are a Ministry Builder.",
  year_1: "A full year since your first gift. Thank you for a year of faithful partnership.",
};

export function MilestoneModal({ mkey, onClose }) {
  useEffect(() => { if (mkey) api.post("/supporter/milestone-ack").catch(() => {}); }, [mkey]);
  const m = mkey ? MILESTONES[mkey] : null;
  const Icon = m?.icon;
  return (
    <AnimatePresence>
      {m && (
        <motion.div className="fixed inset-0 z-[100] flex items-center justify-center p-6" data-testid="milestone-modal"
          initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}>
          <div className="absolute inset-0 bg-charcoal/70 backdrop-blur-sm" onClick={onClose} />
          <motion.div initial={{ scale: 0.9, y: 24 }} animate={{ scale: 1, y: 0 }} exit={{ scale: 0.95, opacity: 0 }}
            transition={{ type: "spring", stiffness: 260, damping: 24 }}
            className="relative bg-bone w-full max-w-md border border-gold shadow-2xl text-center p-10">
            <button onClick={onClose} data-testid="milestone-close" className="absolute top-4 right-4 text-charcoal/40 hover:text-rust transition-colors"><X size={20} /></button>
            <motion.span initial={{ letterSpacing: "0.1em", opacity: 0 }} animate={{ letterSpacing: "0.3em", opacity: 1 }} transition={{ delay: 0.15 }}
              className="font-mono text-xs uppercase tracking-[0.3em] text-gold block">Milestone Reached</motion.span>
            <motion.div initial={{ scale: 0.6, rotate: -12, opacity: 0 }} animate={{ scale: 1, rotate: 0, opacity: 1 }} transition={{ delay: 0.3, type: "spring", stiffness: 200 }}
              className="mx-auto mt-6 w-20 h-20 bg-navy flex items-center justify-center">
              {Icon && <Icon size={40} className="text-gold" strokeWidth={1.4} />}
            </motion.div>
            <motion.h2 initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.45 }}
              className="font-serif text-4xl tracking-tight mt-6">{m.name}</motion.h2>
            <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.55 }}
              className="font-sans text-charcoal/65 mt-3">{NOTE[mkey]}</motion.p>
            <button onClick={onClose} data-testid="milestone-continue"
              className="mt-8 bg-navy text-bone px-10 py-3.5 font-mono text-xs uppercase tracking-widest hover:bg-charcoal transition-colors">
              Continue
            </button>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
